import Pusher from "pusher-js";

let PUSHER_KEY = "0b6cf3996f5bbcec0594";
let PUSHER_CLUSTER = "mt1";
let pusher = new Pusher(PUSHER_KEY, {
  cluster: PUSHER_CLUSTER,
  encrypted: true,
});
// Pusher.log = (msg) => {
//   console.log(msg);
// };
export default pusher;



// WEBPACK FOOTER //
// ./src/app/pusherConfig.js